export const RETRY_ATTEMPTS = 2;
export const SEARCH_RESULTS_LIMIT = 20;
export const DISPLAY_RESULTS_LIMIT = 20;

export const MATCH_START = "@@@START@@@";
export const MATCH_END = "@@@END@@@";
